/*
 * 戒导航 · 头像审核 —— 前台「二次复核记录」模型
 *
 * 设计依据：doc/内容二次复核队列设计方案.md（v1.1）§4.8。
 *
 * 这个类的前台用途只有一个：**作为通知 subject 的占位模型**，
 * 让通知接口返回的 subject 资源能进入 app.store（详见 ./extend.ts 的 ① 段说明）。
 * 组件本身并不读取它的字段（通知正文所需的快照全部在 notification.content() 里，
 * 见 ContentViolationNotification / ContentViolationBlueprint::getData()）。
 *
 * 属性与后端一一对应（只读，记录行是处置凭证，客户端不允许改写）：
 *   JieDH\AvatarGuard\Api\Resource\SecondReviewResource::fields()
 * type 名 'secondReviews' 必须与 SecondReviewResource::type() 完全一致。
 */
import Model from 'flarum/common/Model';

/**
 * 二次复核记录（记录一条「已放行内容」的抽查待办 / 违规档案）。
 */
export default class SecondReview extends Model {
  /** 内容域：avatar / post_text / post_image（本期仅 avatar）。 */
  scope() {
    return Model.attribute('scope').call(this);
  }

  /** 状态：passed（待复核）/ reverted（已驳回，违规档案）/ superseded（已过期失效）。 */
  status() {
    return Model.attribute('status').call(this);
  }

  /** 放行来源：aliyun_pass（阿里云判定通过）/ fail_pass（调用失败降级放行）。 */
  source() {
    return Model.attribute('source').call(this);
  }

  /** 管理员填写的复核备注（驳回原因），可空。 */
  reviewNote() {
    return Model.attribute('reviewNote').call(this);
  }

  /** 记录创建时间。 */
  createdAt() {
    return Model.attribute('createdAt', value => value ? new Date(value) : null).call(this);
  }
}
flarum.reg.add('jiedh-avatar-guard', 'forum/models/SecondReview', SecondReview);